// removed by extract-text-webpack-plugin
module.exports = {"button":"_3tfm8","altPrimary":"lpgPF","primary":"_3uUpH","active":"_2e6J8","large":"Pq41l"};